module.exports = __webpack_public_path__ + "img/hok3.d72e1ac7.png";